import React, { useEffect } from "react";
import { Landing } from "./pages/Landing";
import { initializeMetaPixel } from "./utils/metaPixel";
const PAGE_TITLE = "Sales Team Practice Ready — Volume 1: Sales Conversation Foundations";
const PAGE_DESCRIPTION = "Volume 1 includes five ready-planned 30-minute sales conversation workshops with facilitator wording, realistic role-play cases and observation sheets, for sales team leaders coaching 3–12 sellers. $27 USD, one time.";
export function App() {
  useEffect(() => {
    initializeMetaPixel();
    document.title = PAGE_TITLE;
    document.documentElement.lang = "en-US";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = PAGE_DESCRIPTION;
  }, []);
  return <Landing data-id="element-0" data-mp="23vkvuhy9gblr" />;
}